import cx from 'classnames';
import {range} from 'lodash';

import {Trans, useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	digits: number;
	onChange: (digits: number) => void;
	fieldClassName?: string;
};

export default function DecimalPlacesConfigRow({digits, onChange, fieldClassName}: Props) {
	const {t} = useTranslation();

	return (
		<div className="fields" data-testid="decimal-places-config-row">
			<div className={cx('field', fieldClassName)}>
				<label>
					<Trans i18nKey="dashboard.widgets.dpValue.decimalPlaces">Decimal places</Trans>
				</label>
				<select
					data-testid="decimal-places-select"
					value={digits}
					onChange={(e) => onChange(parseInt(e.target.value, 10))}>
					{range(11).map((num) => (
						<option key={num} value={`${num}`}>
							{num === 0
								? t('dashboard.widgets.dpvalue.none', {
										defaultValue: 'None'
								  })
								: num}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}
